import React from "react";

const movieImages="http://image.tmdb.org/t/p/w1280";
const setVoteClass = (vote)=>{
  if (vote >= 8) {
    return "green"
  } else if (vote >= 6) {
    return "orange"
  }else{
    return "red"
  }
}
const Movie = ({title,poster_path,overview,vote_average}) => {

    return (
        <div >
       <div className="movie ">
       <img src={poster_path ?
         movieImages + poster_path :
          "https://images.unsplash.com/photo-1458053688450-eef5d21d43b3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
         } alt={title} />
    
   <div className= "movie-info ">
     <h3>{title}</h3>
      
   <span className={`
   tag ${setVoteClass(vote_average)}`}
   > {vote_average}</span>
  </div>
   <div className="movie-over">
   <h2>Overview</h2>
    <p>
      {overview}
    </p>
   </div>
   </div>
   </div>
    )
}

 
export default Movie;